
(() => {
  const popup = document.getElementById('pom-newsletter');
  if (!popup) return;

  const form = popup.querySelector('form');
  const key = 'pom-popup-signup-pending';

  form?.addEventListener('submit', () => {
    try {
      sessionStorage.setItem(key, '1');
    } catch (e) {}
  });

  let pending = false;
  try {
    pending = sessionStorage.getItem(key) === '1';
  } catch (e) {}

  const successPanel = popup.querySelector(
    '[data-pom-promo-success]'
  );

  const confirmed = new URLSearchParams(
    window.location.search
  ).get('customer_posted') === 'true';

  if (!successPanel && !(pending && confirmed)) return;

  let panel = successPanel;

  if (!panel) {
    panel = document.createElement('div');
    panel.className = 'pom-promo-reveal';
    panel.innerHTML = `
      <p>WELCOME TO THE INNER CIRCLE</p>
      <strong>MERCY10OFF</strong>
      <button type="button" data-copy-mercy>
        COPY CODE
      </button>
      <p>Apply your discount at checkout.</p>
    `;
    form?.appendChild(panel);
  }

  form?.querySelectorAll(
    'input, label, button[type="submit"]'
  ).forEach(element => {
    element.style.display = 'none';
  });

  popup.hidden = false;
  panel.hidden = false;

  panel.querySelector('[data-copy-mercy]')
    ?.addEventListener('click', async (event) => {
      try {
        await navigator.clipboard.writeText('MERCY10OFF');
        event.currentTarget.textContent = 'COPIED';
      } catch (e) {
        event.currentTarget.textContent = 'MERCY10OFF';
      }
    });

  try {
    sessionStorage.removeItem(key);
  } catch (e) {}
})();